import React from 'react';
import { useHistory } from 'react-router';

// mui
import { Grid, TextField, MenuItem } from '@mui/material';

// block groups
import TableWithSearch from '../../../../../blockGroups/table/TableWithSearch/TableWithSearch.blockgroup';

// utils
import { cleanJobsData } from './JobListWithSearch.collection.utils';
import { dateComparator } from '../../../../../shared/sorting/dates';
import { useTableSort } from '../../../../../shared/hooks/useTableSort';
import { useTableFilter } from '../../../../../shared/hooks/useTableFilter';

const jobSearchFieldOptions= [
    {value: "id", title: "Number"},
    {value: "name", title: "Name"},
    {value: "customerName", title: "Customer"},
];

const jobColumnConfigs = [
    { 
        name: "number", 
        title: "Number", 
        objectFieldsToDisplay: ["id"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'number',
        align: 'left',
        headerAlign: 'left' 
    },
    { 
        name: "customer", 
        title: "Customer", 
        objectFieldsToDisplay: ["customerName"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "name", 
        title: "Name", 
        objectFieldsToDisplay: ["name"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "address", 
        title: "Address", 
        objectFieldsToDisplay: ["address"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "estStartDate", 
        title: "Est. Start Date", 
        objectFieldsToDisplay: ["estimatedStartDate"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: "date",
        sortComparator: dateComparator
    },
];

const jobFilterFieldOptions = [
    { value: "active", title: "Active" },
    { value: "inactive", title: "Inactive" },
    { value: "all", title: "All"},
]



const JobListWithSearch = ({data = { allJobs: [] }, loading, error, onAddClick, pageProps }) => {
    const sortModel = useTableSort(pageProps.location.search, { field: "estStartDate", sort: "desc"})
    const filterBy = useTableFilter(pageProps.location.search, "active")
    const handleSortChange = (newSortModel) => {
        if(newSortModel.length > 0) {
            history.push(`/jobs?sortField=${newSortModel[0].field}&sortDirection=${newSortModel[0].sort}`)
        } else {
            history.push(`/jobs?sortField=${""}&sortDirection=${""}`)
        }
    }
    const setFilterBy = (newFilter) => {
        if(sortModel.length > 0) {
            history.push(`/jobs?sortField=${sortModel[0].field}&sortDirection=${sortModel[0].sort}&filterBy=${newFilter}`)
        } else {
            history.push(`/jobs?sortField=${""}&sortDirection=${""}&filterBy=${newFilter}`)
        }
    }

    const history = useHistory()
    const cleanedData = [...cleanJobsData(data.allJobs, filterBy)]

    const handleRowClick = (rowData) => {
        history.push(`jobs/${'id' in rowData ? rowData.id : ""}`)
    }

    const addButtonConfig = {
        text: "New Job",
        onClick: onAddClick
    }

    return (<Grid container>
        <Grid item>
            <TextField 
                select
                size={'small'}
                value={filterBy}
                onChange={(e) => setFilterBy(e.target.value)}
                fullWidth
                sx={{ marginBottom: 4}}
            >
                {
                    jobFilterFieldOptions.map(option => {
                        return (<MenuItem key={option.value} value={option.value}>{option.title}</MenuItem>)
                    })
                }
            </TextField>
        </Grid>
        <TableWithSearch 
            rawData={cleanedData} 
            loading={loading} 
            error={error} 
            searchFieldOptions={jobSearchFieldOptions} 
            columnConfigs={jobColumnConfigs} 
            addButtonConfig={addButtonConfig}
            onRowClick={handleRowClick}
            sortModel={sortModel}
            onSortModelChange={handleSortChange}
            pageProps={pageProps}
        />
    </Grid>
    )
}

export default JobListWithSearch;